import React from "react";

import { footerMenu } from "data/links";

import { A } from "core/Typography";
import { TextLink } from "./styles";

export const TextLinksContent = () => (
    <>
        {footerMenu.map(link => {
            return (
                <TextLink key={link.name}>
                    <A
                        href={link.href}
                        target={link.external ? "_blank" : "_self"}
                    >
                        {link.name}
                    </A>
                </TextLink>
            );
        })}
    </>
);
